export interface AemAsset {
  source: string;
  description: string;
  title: string;
}

export interface ImageSources {
  src: string;
  media: string;
}

export interface StageCampaignData {
  hide: string;
  headline?: string;
  description?: string;
  imageUrl: AemAsset;
  imageUrlMid: AemAsset;
  imageUrlSmall: AemAsset;
  ctaLabel?: string;
  ctaLink?: string;
  secondaryLabel?: string;
  secondaryLink?: string;
  showCampaignTag: string;
  campaignTagLabel?: string;
  theme: StageTheme;
  verticalAlign: VerticalAlignment;
  horizontalAlign: HorizontalAlignment;
  analytics: string;
}

export interface PromotionTrackingEvent {
  id: string | undefined;
  name: string;
  creative: string;
  position: string;
}

export enum StageTheme {
  light = 'light',
  dark = 'dark',
}

export enum HorizontalAlignment {
  left = 'left',
  center = 'center',
  right = 'right',
}

export enum VerticalAlignment {
  top = 'top',
  middle = 'middle',
  bottom = 'bottom',
}

export enum PriceTrackingEventType {
  fcis = 'fcis',
  pp = 'pp',
}
